import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import StaticCriteriaArguments from '../filter-options/static-criteria-arguments';
import FilterBar from '../../../components/filter-bar';
import { useProductContext } from './product-context';
import allFilterBys from '../filter-options';
import { criteriaOperatorsMap } from '../../../containers/base-filter-bar-container/criteria-operators';
import { getCriteriaArguments } from '../../../containers/customers-filter-bar-container/criteria-arguments';

import style from '../../../containers/orders-filter-bar-container/style.module.less';
import { FormattedMessage } from 'react-intl';
import FilterCheckbox from './checkbox';
import messages from '../messages';

const showInactiveCheckboxLabel = <FormattedMessage {...messages.filterBarShowInactive} />;

const ProductsFilterBar = () => {
  const { appliedFilters, clearFilters, onFiltersChanged } = useProductContext();
  const baseCriteriaArguments = useSelector(getCriteriaArguments);
  const criteriaArgumentsMap = useMemo(
    () => ({
      ...baseCriteriaArguments,
      ...StaticCriteriaArguments,
    }),
    [baseCriteriaArguments],
  );

  const showInactive = useMemo(() => appliedFilters.find(({ filterById }) => filterById === 'showInactive'), [appliedFilters]);

  const toggleShowInactive = useCallback(() => {
    const newFilters = appliedFilters.filter(({ filterById }) => filterById !== 'showInactive');
    if (!showInactive) {
      newFilters.push({
        criterionArgumentValue: true,
        filterById: 'showInactive',
        filterValue: 'ShowInactive',
        id: 'showInactive',
        type: 'TYPE_BOOLEAN',
      });
    }
    onFiltersChanged(newFilters);
  }, [appliedFilters, onFiltersChanged, showInactive]);

  return (
    <>
      <div className={style['filter-bar-wrapper']}>
        <FilterBar
          allFilterBys={allFilterBys}
          appliedFilters={appliedFilters}
          clearFilters={clearFilters}
          criteriaArgumentsMap={criteriaArgumentsMap}
          criteriaOperatorsMap={criteriaOperatorsMap}
          onFiltersChanged={onFiltersChanged}
          popularFilterBys={allFilterBys}
        />
      </div>
      <div className={style['filter-bar-actions-wrapper']}>
        <div className={style['sidebar-toggle']}>
          <FilterCheckbox isChecked={showInactive} label={showInactiveCheckboxLabel} onChecked={toggleShowInactive} />
        </div>
      </div>
    </>
  );
};

export default ProductsFilterBar;
